import apiInstance from "api";


const CommonApiService = {
  getServiceStatus: async () => {
    return await apiInstance.get("/healthcheck/all");
  },
  getStates: async () => {
    return await apiInstance.get("/company-listing/states");
  },
  getCountries: async (fitlers) => {
    return await apiInstance.get(`/company-listing/countries`, {
      params: {
        ...fitlers,
      },
    });
  },
};

export default CommonApiService;
